import {Header} from './Header.';
import Footer from './Footer';
import StoreFilter from './StoreFilter';
import StoreCard from './StoreCard';
import StorePub from "../Images/Icones/StorePub.svg";
import StorePub2 from "../Images/Icones/StorePub2.svg";
import noResults from '../Images/no-results.gif';
import resultsLoader from '../Images/results-loader.gif';
import "./Styles/store.css";
import axios from "axios"
import React, {useEffect, useState} from "react";
import './Styles/preloader.css'
import {getAdById} from '../Services/Ads';
import ProductCard from './ProductCard';

export const Store = () => {
    const [subCategories, setSubCategories] = useState([]);
    const [results, setResults] = React.useState([]);
    const [filterOrder, setFilterOrder] = React.useState('recent')
    const [filterCategory, setFilterCategory] = React.useState(0)
    const [filterPrice, setFilterPrice] = React.useState([])
    const [filterLoading, setFilterLoading] = React.useState(false)
    const [page, setPage] = React.useState(1)
    const [hasMore, setHasMore] = React.useState(true)
    const [defaultRange, setDefaultRange] = React.useState({})
    const [filterSearch, setFilterSearch] = React.useState('');
    const [queryCategory, setQueryCategory] = React.useState(null)
    const [querySearch, setQuerySearch] = React.useState(null)
    const [loading, setLoading] = useState(true)
    const items = 9;

    const [headerAd, setHeaderAd] = useState('');
    const [leftAd, setLeftAd] = useState('');
    const [isSearch, setIsSearch] = useState(false)

    useEffect(() => {
        let tmp = getAdById(10);

        setHeaderAd(tmp.image ? tmp.image : '')

        tmp = getAdById(11);

        setLeftAd(tmp.image ? tmp.image : '')

    }, [window.sessionStorage.getItem('ads')])

    var isLoad = true;
    var firstLoad = false;

    document.title = "Boutique - KabaaShop"

    var requestsDone = 0

    axios.interceptors.response.use(function (response) {
        ++requestsDone

        if (requestsDone == 2) {
            setLoading(false)
        }

        return response;
    })

    if (!loading) {
        document.getElementById('preloader').classList.add('hide')
        document.querySelector('body').style.overflowY = 'scroll'
    }

    useEffect(() => {
        if (!isSearch) {
            axios.get(process.env.REACT_APP_API_BASE_URL + '/api/categories?exists[parent]=true', {
                headers: {
                    'x-api-token': process.env.REACT_APP_API_TOKEN
                }
            }).then(a => {
                setSubCategories(a.data);
            }).catch(error => {
                console.log(error);
            })

            axios.get(process.env.REACT_APP_API_BASE_URL + '/custom/get_range_prices', {
                headers: {
                    'x-api-token': process.env.REACT_APP_API_TOKEN
                }
            }).then(a => {
                setDefaultRange(a.data[0])
            }).catch(error => {
                console.log(error);
            })

            const queryParameters = new URLSearchParams(window.location.search)

            if (queryParameters.get("category") !== null) {
                axios.get(process.env.REACT_APP_API_BASE_URL + '/api/categories?slug=' + queryParameters.get("category"), {
                    headers: {
                        'x-api-token': process.env.REACT_APP_API_TOKEN
                    }
                }).then(a => {
                    if (a.data.length > 0) {
                        setFilterCategory(a.data[0].id)
                        setQueryCategory(a.data[0].id)
                    }
                }).catch(error => {
                    console.log(error);
                })
            } else if (queryParameters.get("search") !== null) {
                setFilterSearch(queryParameters.get("search"))
                setQuerySearch(queryParameters.get("search"))
                setIsSearch(true)

            } else {
                loadProducts()
            }
        }

        document.addEventListener('DOMContentLoaded', function () {
            window.scrollTo({top: 0, behavior: 'smooth'})
        })
    }, [isLoad])

    useEffect(() => {
        if (querySearch && isSearch) {
            loadProducts()
        }

        if ((!firstLoad && !isSearch && !loading)) {
            setIsSearch(false)
            loadProducts()
        }
        firstLoad = true
    }, [filterOrder, filterCategory, filterPrice, filterSearch, page])

    const [goFixed, setFixed] = useState(false);
    const [lastScrollTop, setLastScrollTop] = useState(0);


    useEffect(() => {
        const handleScroll = () => {
            const currentScroll = window.pageYOffset;
            if (currentScroll > lastScrollTop) {
                if (currentScroll >= 245) {
                    setFixed(true);
                }
            } else if (currentScroll <= 240) {
                setFixed(false);
            }
            setLastScrollTop(currentScroll <= 0 ? 0 : currentScroll);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollTop]);

    const filterProducts = (params) => {
        if (params.order !== undefined) {
            setFilterOrder(params.order)
        }

        if (params.category !== undefined) {
            setFilterCategory(params.category)
        }

        if (params.price !== undefined) {
            setFilterPrice([params.price.min, params.price.max])
        }

        if (params.search !== undefined) {
            setFilterSearch(params.search)
        }
    }

    const loadProducts = (search = false) => {
        setFilterLoading(true);

        let url = process.env.REACT_APP_API_BASE_URL + '/api/products?itemsPerPage=' + items;

        //add order
        url += filterOrder === 'recent' ? '&order[id]=desc' : "&order[" + filterOrder.split('-')[0] + "]=" + filterOrder.split('-')[1];

        //add category
        if (filterCategory !== 0) {
            url += '&category.id=' + filterCategory;
        }

        //add price filter
        if (filterPrice.length > 0) {
            url += '&price[between]=' + filterPrice[0] + '..' + filterPrice[1];
        }

        //add search filter
        if (filterSearch !== '') {
            url += '&name=' + encodeURIComponent(filterSearch);
        }

        //add page
        if (page > 1) {
            url += '&page=' + page;
        }

        axios.get(url, {
            headers: {
                'x-api-token': process.env.REACT_APP_API_TOKEN,
                'Accept': 'application/ld+json'
            }
        }).then(a => {
            if (page > 1) {
                let currentResults = results
                currentResults = currentResults.concat(a.data["hydra:member"])

                setResults(currentResults);
            } else {
                setResults(a.data["hydra:member"]);
            }

            if (a.data["hydra:view"]["hydra:next"] === undefined) {
                setHasMore(false);
            }

            setFilterLoading(false)

            setIsSearch(search)

        }).catch(error => {
            console.log(error);
        })
    }

    const toNextPage = () => {
        let currentPage = page
        setPage(++currentPage)
    }

    return (
        <>
            <div id='preloader' className="loading">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
            </div>
            <Header/>
            {
                headerAd !== '' ?
                    (
                        <div className="store-pub-img">
                            <img src={process.env.REACT_APP_ADS_BASE_URL + headerAd} alt="StorePub"/>
                        </div>
                    ) :
                    ''
            }

            <div
                style={!goFixed ? {display: "none"} : window.innerWidth > 770 ? {display: "none"} : {height: "175px"}}></div>
            <div className='store-container'>
                <div
                    className={window.innerWidth > 770 ? "store-filter-container" : goFixed ? "store-filter-container-fixed" : "store-filter-container"}>
                    <StoreFilter querySearch={querySearch} queryCategory={queryCategory} loading={filterLoading}
                                 setLoading={setFilterLoading} setPage={setPage} defaultRange={defaultRange}
                                 filterProducts={filterProducts} subCategories={subCategories}/>

                    {
                        leftAd !== '' ?
                            (
                                <div className="store-pub2-img">
                                    <img src={process.env.REACT_APP_ADS_BASE_URL + leftAd} alt="StorePub2"
                                         style={{height: "225px", maxHeight: "225px"}}/>
                                </div>
                            ) :
                            ''
                    }

                </div>

                <div className='store-products-container'>
                    {
                        filterLoading && page === 1 ? (
                            <div className="results-loader">
                                <img src={resultsLoader}/>
                            </div>
                        ) : (
                            results.length == 0 ? (
                                <div className="no-results">
                                    <div>
                                        <img src={noResults}/>
                                        <p>Aucun résultat n'a été trouvé !</p>
                                    </div>
                                </div>
                            ) : (
                                <StoreCard results={results} fetchData={toNextPage} hasMore={hasMore}/>
                            )
                        )
                    }
                </div>
            </div>

            <Footer/>

        </>
    );
}